module.exports = __webpack_public_path__ + "static/media/Updated.517cd04a.svg";